import Global from '../shared/global';

const $ = jQuery.noConflict();

'use strict';
const equalHeightsItems = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */

	/** @description Initialize */
	init: function() {
		this.equalHeight();
	},

	/** @description slider example description e.g Banner slider */
	equalHeight: ()=> {
		if (window.innerWidth > 767) {
			Global.equalHeights($('.js-cores-title'));
			Global.equalHeights($('.events-list__main-info-title'));
		}

		if (window.innerWidth > 575) {
			Global.equalHeights($('.js-blog-cards-content'));
			Global.equalHeights($('.js-latest-blog-content'));
		}

		Global.equalHeights($('.js-icons-block-name'));
	},
};

export default equalHeightsItems;


